(() => {
  if (customElements.get('vyle-top-gallery')) return;
  customElements.define('vyle-top-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._controller = new AbortController();
      const { signal } = this._controller;
      this.viewport = this.querySelector('.vtg-viewport');
      this.slides = [...this.querySelectorAll('.vtg-slide')];
      this.thumbs = [...this.querySelectorAll('[data-vtg-go]')];
      this.dialog = this.querySelector('dialog');
      const select = index => this.update(Math.max(0, Math.min(index, this.slides.length - 1)));
      this.addEventListener('pointerdown', () => { this._suppressClick = false; }, { signal, passive:true });
      this.addEventListener('click', event => {
        if (this._suppressClick) { event.preventDefault(); this._suppressClick = false; return; }
        const target = event.target.closest('button,a');
        if (!target) return;
        if (target.hasAttribute('data-vtg-go')) { event.preventDefault(); select(Number(target.dataset.vtgGo)); }
        if (target.hasAttribute('data-vtg-prev')) select(this.current - 1);
        if (target.hasAttribute('data-vtg-next')) select(this.current + 1);
        if (target.hasAttribute('data-vtg-zoom')) {
          const img = this.slides[this.current].querySelector('img');
          const large = this.querySelector('[data-vtg-large]');
          large.src = img.currentSrc || img.src; large.alt = img.alt;
          this._zoomTrigger = target; this.dialog.showModal();
        }
        if (target.hasAttribute('data-vtg-close')) this.dialog.close();
      }, { signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); select(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal });
      /* A deliberate sideways swipe changes the image; vertical movement stays native page scrolling. */
      this.viewport.addEventListener('pointerdown', event => {
        this._suppressClick = false;
        this._start = event.isPrimary && event.pointerType !== 'mouse' ? { x:event.clientX,y:event.clientY,id:event.pointerId } : null;
      }, { signal, passive:true });
      this.viewport.addEventListener('pointerup', event => {
        const start = this._start; this._start = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          this._suppressClick = true;
          select(this.current + (dx < 0 ? 1 : -1));
        }
      }, { signal, passive:true });
      this.viewport.addEventListener('pointercancel', () => { this._start = null; }, { signal, passive:true });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog.addEventListener('close', () => this._zoomTrigger?.focus({ preventScroll:true }), { signal });
      this.update(0);
    }
    update(index) {
      this.current = Math.max(0, Math.min(index, this.slides.length - 1));
      this.slides.forEach((slide,i) => { slide.hidden = i !== this.current; });
      this.querySelector('[data-vtg-current]').textContent = String(this.current + 1);
      this.querySelector('[data-vtg-prev]').disabled = this.current === 0;
      this.querySelector('[data-vtg-next]').disabled = this.current === this.slides.length - 1;
      this.thumbs.forEach((thumb,i) => { if (i === this.current) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current'); });
    }
    disconnectedCallback() { this._controller?.abort(); this._connected = false; this._start = null; }
  });
})();
